export enum ErrorCodes {
  emailIsCustomerKey = "emailIsCustomerKey",
  adminAlreadyExists = "adminAlreadyExists"
}
